import { render, staticRenderFns } from "./DotsComponent.vue?vue&type=template&id=2f5c8908&scoped=true&"
import script from "./DotsComponent.vue?vue&type=script&lang=js&"
export * from "./DotsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c8908",
  null
  
)

export default component.exports